import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';

@Pipe({
	name: 'countryDesc'
})
export class CountryDescPipe implements PipeTransform {

	private countryCodes$ = this.store.select(fromStore.getSelectedCountryConversionCodesOpts);

	constructor(
		private store: Store<fromStore.State>
	) {}

	transform(value: any, args?: any): any {
		if (!_.isNil(value)) {
			let desc = '';
			this.countryCodes$
				.pipe(
					map(data => data.find(dt => Object.is(value, dt.value)))
				)
				.subscribe((data: any) => desc = data.text);
			return desc;
		}
		return '';
 	}

}
